import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import { TextButtonLink } from 'js/design_system/link/TextButtonLink';

import { CtaIcon } from './autotest/AutotestFocusedNav';
import CtaIconLock from './CtaIconLock';
import { NewUserDiscount } from './types';

const MobileNavButtonContainer = styled.div`
  flex-shrink: 1;
  --buttons-small-buttons-height: 40px;
  --buttons-small-buttons-l-r-padding: var(--spacing-xs-8, 8px);
  text-align: center;
`;

type PremiumTextProps = {
  reactivate?: string;
  coupon?: string;
  newUserDiscount?: NewUserDiscount;
  trialPricingCopy?: string;
  /**
   * Autotest CTA label override (AutotestFocusedNav `ctaLabel` surface). When
   * null/undefined (control), the offer-derived default copy below is used.
   */
  ctaLabel?: string | null;
  /** Autotest CTA icon override (AutotestFocusedNav `ctaIcon` surface). */
  ctaIcon?: CtaIcon;
  // NB: no ctaEmphasis here — the 'gold' treatment is desktop-only (this mobile
  // TextButtonLink is a transparent text button that doesn't consume the gold
  // fill var; see PremiumUpsellButton).
};

const PremiumText = ({
  reactivate,
  coupon,
  newUserDiscount,
  trialPricingCopy,
  ctaLabel,
  ctaIcon = 'lock',
}: PremiumTextProps) => {
  let url;
  let ctaText;

  if (trialPricingCopy) {
    ctaText = trialPricingCopy;
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'nav-btn-trial',
      from_navbar: true,
    });
  } else if (newUserDiscount) {
    const { feature, trigger, couponCode } = newUserDiscount;
    url = routes.checkout_url({
      feature,
      trigger,
      coupon_code: couponCode,
      from_navbar: true,
    });
    ctaText = '6 Months Free!';
  } else if (reactivate) {
    url = routes.checkout_url({
      feature: 'default',
      trigger: 'nav-btn-reactivate',
      premium_discount_coupon: coupon,
      from_navbar: true,
    });
    ctaText = 'Reactivate 50% Off';
  } else {
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'default',
      from_navbar: true,
    });
    ctaText = 'Get Premium';
  }

  // Autotest override: a variant may replace the offer-derived copy (control
  // leaves ctaLabel null → unchanged). The url/trigger stay tied to the offer.
  if (ctaLabel) {
    ctaText = ctaLabel;
  }

  return (
    <MobileNavButtonContainer>
      <TextButtonLink
        href={url}
        icon={
          <CtaIconLock ctaIcon={ctaIcon} circleColor="gold" lockColor="white" />
        }
        size="sm"
      >
        {ctaText}
      </TextButtonLink>
    </MobileNavButtonContainer>
  );
};

export default PremiumText;
